const invalidOperationNames = [
  '# GraphQLParseFailure',
  '# GraphQLValidationFailure',
  '# GraphQLUnknownOperationName',
  '# CardinalityLimitExceeded',
];

export function isOperationUnexecutable(displayName: string): boolean {
  return invalidOperationNames.includes(displayName);
}

export function unexecutableOperationReason(displayName: string): string {
  if (displayName === '# CardinalityLimitExceeded') {
    return 'This operation was redacted due to cardinality limits.';
  }
  let nonExecutableOperationContent =
    'This operation could not be executed against your graph because ';
  if (displayName === '# GraphQLParseFailure') {
    nonExecutableOperationContent += 'it did not parse as GraphQL.';
  } else if (displayName === '# GraphQLValidationFailure') {
    nonExecutableOperationContent += 'it did not validate against your schema.';
  } else if (displayName === '# GraphQLUnknownOperationName') {
    nonExecutableOperationContent +=
      'requested operation name was not found in GraphQL document. Please check the correct operation name is being sent.';
  } else {
    throw new Error(
      `Operation name did not match one of ${invalidOperationNames.toString}`,
    );
  }
  return nonExecutableOperationContent;
}

/**
 * Patch over some gaps in error stats where we don't have the operation name
 * but we can recognize the operation ID.
 */
export function unexecutableOperationNameForId(
  id: string | null,
): string | null {
  switch (id) {
    case 'ea4f152696abedca148b016d72df48842b713697':
    case '15b0987fd8bb540379db0ecb6e5ab75f9f385b1d': // incorrectly hashed from validation failures
      return '# GraphQLValidationFailure';
    case '7486043da2085fed407d942508a572ef88dc8120':
    case '823c4a30458fd62a49d2393a2777ddab1a9d43d3': // incorrectly hashed from unkown operations
      return '# GraphQLUnknownOperationName';
    case '3f410834f13153f401ffe73f7e454aa500d10bf7':
    case '1f08e40c1ec077e7376b0f0945ba1bee09ba753b': // incorrectly hashed from parse failures
      return '# GraphQLParseFailure';
    default:
      return null;
  }
}
